import React, { Component } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import cm from 'helpers/commons';

class HLineChart extends Component {
  monetaryUnit = (num) => {
    return cm.monetaryUnit(num);
  };

  commons = (value, name, props) => {
    return cm.numberComma(value);
  };

  render() {
    const { width, height, data, legend } = this.props;

    let lineChart = '';
    if (data && data.length > 0) {
      lineChart = (
        <LineChart width={width} height={height} data={data} margin={{ top: 20, right: 20, left: 20, bottom: 10 }}>
          <XAxis dataKey="name" />
          <YAxis yAxisId="left" orientation="left" stroke="#82ca9d" tickFormatter={this.monetaryUnit} />
          <YAxis yAxisId="right" orientation="right" stroke="#ECB632" />

          <CartesianGrid strokeDasharray="5 5" />
          <Tooltip formatter={this.commons} />
          {legend ? <Legend payload={legend} /> : ''}

          <Line
            yAxisId="left"
            type="linear"
            dataKey="식대금액"
            unit={cm.unit()}
            stroke="#82ca9d"
            activeDot={{ r: 8 }}
          />
          <Line yAxisId="right" type="monotone" dataKey="사용자별" stroke="#ECB632" activeDot={{ r: 8 }} />
        </LineChart>
      );
    } else {
      lineChart = (
        <div className="box-mid">
          <div className="mid">
            <h3>데이터 내역이 없습니다.</h3>
          </div>
        </div>
      );
    }

    return <div style={{ width: width, height: height }}>{lineChart}</div>;
  }
}

export default HLineChart;
